import { apiFetch } from './client'
import type { WalletBalance } from '../types/wallet'

export function fetchWalletBalances(portfolioId: string): Promise<WalletBalance[]> {
  return apiFetch<WalletBalance[]>(`/api/wallet/${encodeURIComponent(portfolioId)}`)
}
